import mean from 'ml-array-mean';
import { xRolling } from './xRolling';
/**
 * This function calculates a rolling average
 *
 * @param array - the array that will be rotated
 * @param options - option
 */
export function xRollingAverage(array, options = {}) {
    return xRolling(array, mean, options);
}
//# sourceMappingURL=xRollingAverage.js.map